// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2012) return "css/2012-5e638456.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + "b7a27ebc" + ".css";
};